import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';

@Injectable({
  providedIn: 'root'
})
export class UvrService {
  getHttpCustomOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: localStorage.getItem('Token'),
        'X-Api-Key': this.environment.uvrKey,
      }),
    };
  }
  getheader = (token) => {
    return {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + token,
      }),
    };
  };

  getBusinessEntity = () => localStorage.getItem('namcvalue');
  getWorkID = () => localStorage.getItem('workdayId');
  getUserRole = () => localStorage.getItem('UserRoles');

  private getPieHeaders(token) {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token.token}` // Assuming token is a string
    });
    const params = {
      business_entity: this.getBusinessEntity(),
      start_date: token.start_date,
      stop_date: token.stop_date,
    };
  
    return { headers, params };
  }
  uvrApiUrl = '';
  pieUrl = '';

  constructor(
    private http: HttpClient,
    private environment: EnvironmentConfiguration
  ) {
    this.uvrApiUrl = environment.uvrUrl;
    this.pieUrl = environment.pieAdrUrl;
  }

  getGraph(data): Observable<any> {
    return this.http.post<any>(
      `${this.uvrApiUrl}/uvr`,
      // 'http://localhost:3000/uvr',
    data,this.getHttpCustomOptions());}
  
  count(data): Observable<any> {
    return this.http.post<any>(
      `${this.uvrApiUrl}/count`,
      // 'http://localhost:3000/count',
      data,
      this.getHttpCustomOptions()
    );
  }

  comments(data): Observable<any> {
    return this.http.post<any>(
      `${this.uvrApiUrl}/action`,
      // 'http://localhost:3000/action',
      data,
      this.getHttpCustomOptions()
    );
  }
  complete(data): Observable<any> {
    return this.http.post<any>(
      `${this.uvrApiUrl}/complete`,
      // 'http://localhost:3000/complete',
      data,
      this.getHttpCustomOptions()
    );
  }
  getPieAdr(token: any): Observable<any> {
    return this.http.get<any>(
      `${this.pieUrl}/address/read-test`,
      this.getPieHeaders(token)
    );
  }
  addComment(data): Observable<any> {
    return this.http.post<any>(
      `${this.uvrApiUrl}/comment`,
      // 'http://localhost:3000/comment',      
      data,
      this.getHttpCustomOptions()
    );
  }
  toBeCounted(data): Observable<any> {
    return this.http.post<any>(
      `${this.uvrApiUrl}/toBeCounted`,
      // 'http://localhost:3000/toBeCounted',
      data,
      this.getHttpCustomOptions()
    );
  }
  raiseUpdateManOdrTapReq(data): Observable<any> {
    return this.http.post<any>(
      `${this.uvrApiUrl}/raiseUpdateManOdrTapReq`,
      // 'http://localhost:3000/raiseUpdateManOdrTapReq',
      data,
      this.getHttpCustomOptions()
    );
  }
  getUvrRefreshDate(data): Observable<any> {
    return this.http.post<any>(
      `${this.uvrApiUrl}/getUvrRefreshDate`,
      // 'http://localhost:3000/getUvrRefreshDate',
      data,
      this.getHttpCustomOptions()
    );
  }
}
